import React, { useContext, Suspense, useMemo } from 'react'
import { useViewport } from '../../../hook/useViewport' // Assuming path is correct
import { ThemeContext } from '../../../context/2025/ThemeContext' // Assuming path is correct
import { motion } from 'framer-motion' // Import motion from framer-motion

// Lazy load Header and Footer components
const Header = React.lazy(() => import('../../../components/2025/Header')) // Assuming path is correct
const Footer = React.lazy(() => import('../../../components/2025/Footer')) // Assuming path is correct

// --- NEW Committee Data Structure ---
const committees = [
  {
    name: 'Programming',
    roles: [
      { title: 'Interim Dean', members: ['Ana Rita Morais'] },
      { title: 'Interim Associate Dean', members: ['Toni Allen'] },
      { title: 'Faculty Lead', members: ['Jen Masters'] },
      { title: 'Student Lead', members: ['Emily Chau'] },
      { title: 'Other members', members: ['Damian Casas'] },
    ],
  },
  {
    name: 'Promotional and Digital Assets',
    roles: [
      { title: 'Lead', members: ['Parsa Abasalt'] },
      { title: 'Co-Lead', members: ['John Hanchar'] },
      {
        title: 'Other members',
        members: [
          'Darya Norouzi Tazeh Kand',
          'Daniel Olea Pinto',
          'Ivan Chan',
          'Manan Ashish Laliwala',
          'Yatharth Vasania',
          'Emily Gouveia',
          'Erica Stacy Krawczyk',
          'Novele Salvanera',
          'Yi Zhang',
        ],
      },
    ],
  },
  {
    name: 'Printed Collateral',
    roles: [
      { title: 'Lead', members: ['John Hanchar'] },
      { title: 'Co-Lead', members: ['Viktoriia Iatsyna'] },
      {
        title: 'Other members',
        members: [
          'Zhanel Adiy',
          'Madina Amanzai',
          'Laura Jenah',
          'Lauren Chan',
          'Sean George Palmattam',
          'Emily Gouveia',
        ],
      },
    ],
  },
  {
    name: 'Website',
    roles: [
      {
        title: 'Faculty Leads',
        members: ['Chris Kim', 'Ali Kokulu', 'Ahmet Kokulu', 'Chris Lange'],
      },
      { title: 'Lead', members: ['Apakhon Piamchao'] },
      { title: 'Co-Lead', members: ['Haniye Reyhani'] },
      {
        title: 'Other members',
        members: ['Gaya Khiani', 'Krystal Nguyen', 'Disha Jaikishan Dhanwani', 'Evelyn Luu'],
      },
    ],
  },
  {
    name: 'Exhibition & Wayfinding',
    roles: [
      { title: 'Lead', members: ['Sara Vargas Nessi'] },
      { title: 'Co-Lead', members: ['Eenaya'] },
      {
        title: 'Other members',
        members: [
          'Siyu Wang',
          'Andrea May',
          'Gaia Luka',
          'Jaylynn Egerton-Brooks',
          'Mayara Gomes De Carvalho Sampaio',
          'Madina Amanzai',
          'Diana Ugnivenko',
          'Divshaan Singh Brar',
          'Charles Jackson',
          'Michael Yokota',
          'Luiza Passos Barboza',
          'Lucia Ferreira Quintero',
        ],
      },
    ],
  },
  {
    name: 'Merchandise',
    roles: [
      { title: 'Lead', members: ['Misbah Intisar'] },
      { title: 'Co-Lead', members: ['Parsa Abasalt'] },
      {
        title: 'Other members',
        members: ['Emily Gouveia', 'Sandy Kuo', 'Alana Wong', 'Saba Rahimi'],
      },
    ],
  },
  {
    name: 'Awards Show',
    roles: [
      { title: 'Lead', members: ['Shweta Singh'] },
      { title: 'Co-Lead', members: ['Radhika Gaur'] },
      {
        title: 'Other members',
        members: ['Jaspreet Kaur', 'Gurmanjot Kaur Grewal', 'Dhruvi Gada', 'Narinder pal Singh'],
      },
    ],
  },
  // --- NEWLY ADDED from comments ---
  {
    name: 'Event Support & Logistics',
    roles: [
      { title: 'YES! Coordinator', members: ['Jen Masters'] },
      { title: 'Maker Lab Lead', members: ['Joseph Zettler'] },
      { title: 'Headshot Photographer', members: ['Viktoriia Iatsyna'] },
      { title: 'Event Photographer', members: ['Emily Chau', 'Ivan Chan'] },
      { title: 'DJ', members: ['John Hanchar (DJ Subverso)'] },
      {
        title: 'Technology Team',
        members: ['Matt McColl Poon', 'Alex Furlott', 'Hein Pham'],
      },
      {
        title: 'Event Greeters',
        members: [
          'Vachara Chhut',
          'Jaspreet Kaur',
          'Miranda Mcconnell',
          'Madina Amanzai',
          'Radhika Gaur',
          'Shweta Singh',
        ],
      },
    ],
  },

  // --- You can add the old "YesTeamPage" specific roles here if needed ---
  // Example:
  // {
  //   name: 'Event Support', // Or keep them separate outside the committee structure
  //   roles: [
  //     { title: 'YES! Coordinator', members: ['Jen Masters'] },
  //     { title: 'Headshot Photographer', members: ['Viktoriia Iatsyna'] },
  //     { title: 'Event Photographer', members: ['Emily Chau', 'Ivan Chan'] },
  //     { title: 'DJ', members: ['John Hanchar (DJ Subverso)'] },
  //     {
  //       title: 'Event Greeters',
  //       members: [
  //         'Vachara Chhut',
  //         'Jaspreet Kaur',
  //         'Miranda Mcconnell',
  //         'Madina Amanzai',
  //         'Radhika Gaur',
  //         'Shweta Singh',
  //       ],
  //     },
  //     {
  //       title: 'Technology Team',
  //       members: ['Matt McColl Poon', 'Alex Furlott', 'Hein Pham'],
  //     },
  //     { title: 'Maker Lab Lead', members: ['Joseph Zettler'] },
  //   ]
  // }
]

// --- Framer Motion Variants (Unchanged) ---
const nameContainerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.03,
    },
  },
}

const letterVariants = {
  hidden: {
    opacity: 0,
    y: -50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      damping: 12,
      stiffness: 100,
    },
  },
}

// --- Component Definition ---
export default function YesTeamPage() {
  const { width } = useViewport()
  const isMobile = width <= 640
  const isMini = width <= 460
  const { isDarkMode } = useContext(ThemeContext)

  // --- Generate stable random delays for name animations ---
  const nameDelays = useMemo(() => {
    const delays = {}
    committees.forEach((committee, committeeIndex) => {
      delays[committeeIndex] = {}
      committee.roles.forEach((role, roleIndex) => {
        delays[committeeIndex][roleIndex] = {}
        role.members.forEach((_member, memberIndex) => {
          delays[committeeIndex][roleIndex][memberIndex] = Math.random() * 1.5 // Max delay 1.5s
        })
      })
    })
    return delays
  }, []) // Recalculate only if committees data structure changes fundamentally (it won't here)

  const backgroundColors = {
    // Define colors for each section, similar to About page
    titleSection: isDarkMode ? 'bg-black' : 'bg-white', // Or another color
    listSection: isDarkMode ? 'bg-dark-grey' : 'bg-light-grey-25', // Example alternation
    footer: isDarkMode ? 'bg-black' : 'bg-light-grey-25',
  }

  const textColors = {
    heading: isDarkMode ? 'text-lime' : 'text-lavender',
    tagline: isDarkMode ? 'text-white' : 'text-black', // For the tagline
    committeeName: isDarkMode ? 'text-lime' : 'text-lavender',
    role: isDarkMode ? 'text-white' : 'text-black',
    name: isDarkMode ? 'text-gray-300' : 'text-gray-700',
    footerText: isDarkMode ? 'text-white' : 'text-black',
  }

  const TextCenterDiv = ({ className, children }) => <div className={className}>{children}</div>

  return (
    <div
      className={`absolute w-full min-h-screen ${backgroundColors.header} flex flex-col items-center justify-start pb-20 lg:pb-0`}
    >
      {Header && <Header />}

      {/* --- Section 1: Title and Tagline --- */}
      <section className={`w-full ${backgroundColors.titleSection} transition-colors duration-300`}>
        <div className='max-w-[1440px] mx-auto px-6 lg:px-[48px] py-24 lg:py-32 flex flex-col items-center justify-center'>
          {' '}
          {/* Adjusted padding */}
          {/* Using TextCenterDiv or equivalent for centering */}
          <TextCenterDiv className='text-center'>
            <h1
              className={`${isMobile ? 'heading-1-mobile' : 'heading-1'} ${
                textColors.heading
              } uppercase ${isMini ? '!text-[54px]' : ''}`}
              style={{ pointerEvents: 'none' }}
            >
              COMMITTEE
            </h1>
            {/* --- Tagline --- */}
            {/* Adjust tagline styling as needed */}
            <h3
              className={`heading-3b ${textColors.tagline} normal-case mt-2 lg:mt-4`}
              style={{ pointerEvents: 'none' }}
            >
              Powered by Collaboration {/* Placeholder Tagline */}
            </h3>
          </TextCenterDiv>
        </div>
      </section>

      {/* --- Section 2: Committees List --- */}
      <section
        className={`w-full ${backgroundColors.listSection} transition-colors duration-300 flex-1`}
      >
        <div className='max-w-[1440px] mx-auto px-6 lg:px-[48px] py-16 lg:py-24'>
          {/* --- Committees List Container --- */}
          <div className='flex flex-col gap-y-12 lg:gap-y-16'>
            {' '}
            {/* Vertical layout for committees */}
            {committees.map((committee, committeeIndex) => (
              <div key={committeeIndex} className='flex flex-col'>
                {/* --- Committee Name --- */}
                <h2
                  className={`heading-2 uppercase ${
                    textColors.committeeName
                  } mb-6 lg:mb-8 border-b pb-2 ${isDarkMode ? 'border-lime' : 'border-lavender'} ${isMini ? '!text-[40px]' : ''}`}
                >
                  {committee.name}
                </h2>

                {/* --- Roles and Members Grid --- */}
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10 lg:gap-y-12'>
                  {committee.roles.map((role, roleIndex) => (
                    <div key={roleIndex} className='flex flex-col text-left'>
                      {/* --- Role Title --- */}
                      <h3
                        className={`heading-3b mb-2 ${textColors.role} normal-case font-semibold`}
                      >
                        {role.title}
                      </h3>

                      {/* --- Members List --- */}
                      <ul className='list-none pl-0'>
                        {role.members.map((name, nameIndex) => {
                          const stableDelay =
                            nameDelays[committeeIndex]?.[roleIndex]?.[nameIndex] || 0
                          return (
                            <motion.li
                              key={nameIndex}
                              className={`body-text !text-[20px] ${textColors.name} overflow-hidden whitespace-nowrap text-ellipsis`}
                              variants={nameContainerVariants}
                              initial='hidden'
                              animate='visible'
                              transition={{ delay: stableDelay }}
                            >
                              {/* Animate letters */}
                              {name.split('').map((char, charIndex) => (
                                <motion.span
                                  key={charIndex}
                                  variants={letterVariants}
                                  className='inline-block'
                                >
                                  {char === ' ' ? '\u00A0' : char}
                                </motion.span>
                              ))}
                            </motion.li>
                          )
                        })}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- Footer Section --- */}
      <div
        className={`relative w-full ${backgroundColors.footer} flex flex-col items-center justify-center transition-colors duration-300 mt-auto`}
      >
        <div className='relative bottom-0 w-full pt-16 px-[16px] lg:px-[48px] max-w-[1440px]'>
          <Footer />
        </div>
      </div>
    </div>
  )
}
